export default __webpack_public_path__ + "static/media/MicroscopyTest.4fff65bf.jpg";